import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";

export default function appointmentsReducer(
  state: number = initialState.holdSecondsRemaining,
  action: AnyAction
): number {
  switch (action.type) {
    case actionTypeKeys.APPT_HOLD_TIME_REMAINING_CHANGED:
      return action.timeRemaining;
    default:
      return state;
  }
}
